<template>
    <div id="emailSequenceModal" class="modal" role="dialog">
        <div class="modal-dialog modal-xl vertical-align-center">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header bg-teal text-white font-bold">
                    <div class="flex">
                        <h4>Sequences</h4>
                        <div v-if="!modalFlag" class="flex flex-row">
                            <span class="flex flex-column">
                            <input type="text" class="sequence-name ml-3" id="sequence_name" disabled v-model="sequenceObj.name" placeholder="New Sequence"/>
                                <span v-if="error.sequenceName" class="text-danger text-sm ml-3">Sequence name is required</span>
                            </span>
                            <span v-if="!editingSequenceName" class="cursor-pointer" @click="editSequenceName"><i class="fa fa-pencil"></i> </span>
                            <span v-if="editingSequenceName" class="cursor-pointer" @click="saveSequenceName"><i class="fa fa-check"></i> </span>
                        </div>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div v-if="modalFlag" class="modal-body bg-white">
                    <div class="flex justify-content-between">
                        <div class="bg-grey-lighter rounded-full w-1/3 flex items-center">
                            <input ref="filter" type="search"
                                   class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-1 rounded-full ml-3 text-sm"
                                   placeholder="Search by name..." @input="debounceFilter" v-model="filter">
                            <div class="flex-1 text-right pr-3">
                                <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest"
                                   aria-hidden="true"></i>
                            </div>
                        </div>

                        <div class="float-right">
                            <b-button class="bg-primary mr-3" pill variant="info"
                                @click.stop.prevent="showSharedSequences()">
                                Shared Sequence
                            </b-button>
                            <b-button class="bg-primary" pill variant="info"
                                @click.stop.prevent="openSequence()">New Sequence
                            </b-button>
                        </div>
                    </div>
                    <div class="bg-white shadow-md rounded mb-6 mt-4">
                        <table class="text-left w-full border-collapse">
                            <thead>
                            <tr>
                                <th class="py-1 pl-2 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold':sort.column === 'name'}"
                                    @click="sortBy('name')">
                                    Sequence Name
                                </th>
                                <th class="py-1 pl-2 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer">
                                    Steps
                                </th>
                                <th class="py-1 pl-2 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold':sort.column === 'last_used'}"
                                    @click="sortBy('last_used')">
                                    Last Used
                                </th>
                                <th class="py-1 pl-2 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold': sort.column === 'updated_at'}"
                                    @click="sortBy('updated_at')">
                                    Last Update
                                </th>
                                <th class="py-1 pl-2 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer text-center">
                                    Action
                                </th>
                            </tr>
                            </thead>
                            <tbody v-if="emailSequences.length>0">
                            <tr class="hover:bg-grey-lighter cursor-pointer border-b-1"
                                v-for="(sequence, idx) in emailSequences" :key="idx">
                                <td class="text-sm pl-2 py-1" style="word-break: break-all">
                                    <div>
                                        {{ sequence.name }}
                                    </div>
                                </td>
                                <td class="text-sm pl-2">
                                    <div>{{ sequence.no_of_steps }}</div>
                                </td>
                                <td class="text-sm pl-2">
                                    <div>{{ sequence.last_used }}</div>
                                </td>
                                <td class="text-sm pl-2">
                                    <div>{{ sequence.updated_at }}</div>
                                </td>
                                <td class="text-sm pl-2 text-center">
                                    <button type="button"
                                            class="material-icons text-md text-grey-darkest pr-2 hover:text-grey-darkest focus:outline-none hover:cursor-pointer"
                                            @click="addSequenceToEmail(sequence)">add
                                    </button>
                                    <button @click="editSequence(sequence)"
                                            class="material-icons text-md text-grey-darkest pr-2 hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                        edit
                                    </button>
                                    <button type="button"
                                            class="material-icons text-md text-grey-darkest pr-2 hover:text-grey-darkest focus:outline-none hover:cursor-pointer"
                                            @click="destroySequence(sequence.id)">delete
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr class="border-b-1">
                                <td colspan="4" class="text-center p-4">No sequence found</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center">
                        <b-pagination
                            @change="goToPage"
                            v-model="pagination.meta.current_page"
                            :total-rows="pagination.meta.total"
                            :per-page="pagination.meta.per_page"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last">
                        </b-pagination>
                    </div>
                </div>

                <div v-else class="modal-body bg-white">
                    <div class="row m-0">
                        <div class="col-md-6 pl-0 modal-min-height">

                            <div class="steps-list-height">
                                <div v-if="showButtons">
                                    <div class="d-flex pt-5 justify-content-center">
                                        <div class="border-1 cursor-pointer shadow-md custom-sequence-button p-2 mr-3 d-flex flex-column justify-content-center text-center" @click="toggleShowButtons">
                                            <span class="w-100">
                                                <img class="sequence-button-image" src="/images/plus-icon-sequence.png" />
                                            </span>
                                            <span>Create your <br> own from scratch</span>
                                        </div>
                                        <div class="border-1 cursor-pointer shadow-md custom-sequence-button p-2 mr-3 d-flex flex-column justify-content-center text-center" @click="toggleShowTemplates">
                                            <span class="w-100">
                                                <img class="sequence-button-image" src="/images/template-icon-sequence.png" />
                                            </span>
                                            <span>Start from <br> premade templates</span>
                                        </div>
                                    </div>
                                </div>

                                <div v-else >
                                    <div v-if="showTemplateSection">

                                        <h3 class="p-3">Premade Template</h3>
                                    <div class="main-container d-flex border-1 text-sm">
                                        <div class="premade-templates-list">
                                            <div v-for="premadeTemplate in premadeTemplates" :key="premadeTemplate.id" class="mb-2 cursor-pointer step-title" :class="{'active': premadeTemplate.id === selectedTemplate.id}" @click="selectTemplate(premadeTemplate)">
                                                {{premadeTemplate.name}}
                                            </div>
                                        </div>
                                        <div class="premade-templates-steps d-flex flex-column text-xs">
                                            <div v-if="selectedTemplate" v-for="(step, index) in selectedTemplate.sequence_steps" class="mb-2 d-flex justify-content-between">
                                                <span class="float-left">
                                                    <span class="step-template-title float-left">{{ index+1 }}. {{ step.template_name }}</span>
                                                    <span> - Day {{ step.send_email_in }} at {{ formatTime(step.step_time)}}</span>
                                                </span>
                                                <span class="preview-btn float-right cursor-pointer" @click="previewTemplate(step)">preview</span>
                                            </div>
                                        </div>

                                    </div>


                                        <div class="steps-button-div">
                                            <b-button class="bg-primary mr-3 cursor-pointer" variant="info" @click="useTemplate">
                                                Use and customize
                                            </b-button>
                                        </div>


                                    </div>
                                    <div v-else>
                                        <div v-if="sequenceSteps.length > 0" v-for="(step, index) in sequenceSteps" @click="selectStep(step)"
                                         class="flex flex-row w-full border-1 shadow-md mr-2 mb-2 p-1 align-items-center text-sm justify-content-between cursor-pointer">
                                            <p class="pr-1 step-title">Step {{ index+1 }}: {{ step.template_name }}</p>
                                            <p class="pr-1">send email in</p>
                                            <select class="dayDropdown" disabled>
                                                <option>{{step.send_email_in}}</option>
                                            </select>
                                            <select class="dayDropdown" disabled>
                                                <option>{{ step.step_unit }}</option>
                                            </select>
                                            <div style="width: 20%; position: relative;">
                                                <div style="position: absolute; left: 10px;">
                                                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                                                </div>
                                                <datetime
                                                    type="time"
                                                    name="scheduled_time"
                                                    disabled format="hh:mm a"
                                                    v-model="step.step_time"
                                                    use12-hour
                                                    :minute-step="15"
                                                    input-style="width:100% !important; padding-left:30px;"
                                                    required id="scheduled_time"
                                                    class="border-1 text-grey-darkest text-sm sequence-timepicker w-100"
                                                ></datetime>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 position-absolute fixed-bottom">
                                <b-button class="bg-primary mr-3" variant="info" @click="backToListing">
                                    Back to listing
                                </b-button>
                                <b-button v-if="!settingsTab" class="bg-primary" variant="info" @click="showSettings(true)">
                                    Settings
                                </b-button>
                                <b-button v-else class="bg-primary" variant="info" @click="showSettings(false)">
                                    Back to steps
                                </b-button>
                            </div>
                        </div>
                        <div v-if="!settingsTab" class="col-md-6">
                            <ckeditor-sequence
                                id="sequenceForm"
                                :project="project"
                                :subSuffix="subSuffix"
                                :sequence="sequenceObj"
                                :selectedStepObj="selectedStepObj"
                                :allFields="allFields"
                                :selectedTemplate="selectedTemplate"
                                :showSendTestBtn="showSendTestBtn"
                                :selectedContactForSequence="selectedContactForSequence"
                                group-values="optionValues"
                                group-label="optionTypes"
                                :group-select="false"
                                track-by="id"
                                label="text"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Select field to add in editor"
                                :showLabels="false"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                :preserve-search="false"
                            ></ckeditor-sequence>
                        </div>
                        <div v-else class="col-md-6 p-4 custom-checkbox-section">
                            <div class="w-100 text-md">
                                <span class="float-left">Share this sequence company wide</span>
                                <span class="float-right">
                                    <input class="setting-checkbox" type="checkbox" id="share_company_wide" v-model="sequenceObj.is_shared" @change="saveSettings()">
                                </span>
                            </div>
                            <div class="w-100 text-md">
                                <span class="float-left">Emails will be sent on business days only</span>
                                <span class="float-right">
                                    <input class="setting-checkbox" type="checkbox" id="business_days_only" v-model="sequenceObj.business_days_only" @change="saveSettings()">
                                </span>
                            </div>
                            <div class="w-100 text-md">
                                <span class="float-left">Unenroll if contact replies to email</span>
                                <span class="float-right">
                                    <input class="setting-checkbox" type="checkbox" id="unenroll_email" v-model="sequenceObj.unenrolled" @change="saveSettings()">
                                </span>
                            </div>
<!--                            <div class="form-check form-check-inline w-100 align-top">-->
<!--                                <label class="form-check-label" for="inlineCheckbox1" style="width:80%">Share this sequence company wide</label>-->
<!--                                <input class="form-check-input float-right" type="checkbox" id="inlineCheckbox1" value="option1">-->
<!--                            </div>-->
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VueTextEditor from "../shared/vue-text-editor";
import CkeditorSequence from "../shared/ckeditor-container-sequence";
import moment from 'moment';
import Multiselect from "vue-multiselect";
export default {
    name: "email-sequence-modal",
    components: {Multiselect, CkeditorSequence},
    props: ['user', 'project', 'selectedContactForSequence', 'allFields', 'subSuffix'],
    data() {
        return {
            showSendTestBtn: false,
            selectedTemplate: null,
            editingSequenceName: false,
            modalFlag: true,
            settingsTab: false,
            sequence_text: '',
            errorFlag: false,
            data_loading: true,
            sequenceObj: {
                id: null,
                name: '',
                is_shared: false,
                business_days_only: false,
                unenrolled: false
            },
            sequenceSteps: [],
            selectedStepObj: null,
            filter: '',
            emailSequences: [],
            sort: {
                direction: 'asc',
                column: 'name'
            },
            page: 1,
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            error: {
                name: '',
                content: '',
                sequenceName: false
            },
            showButtons: false,
            showTemplateSection: false,
            premadeTemplates: []
        }
    },
    mounted() {
        this.fetchData();
        this.fetchTemplates();
        Bus.$on('onSequenceNameEmpty', data => {
            this.error.sequenceName = true;
        });
        Bus.$on('newStepAdded', data => {
            this.selectedStepObj = null
            this.sequenceSteps.push(data);
            this.showButtons = false;
        });
        Bus.$on('newSequenceAdded', data => {
            this.sequenceObj = data;
        });
        Bus.$on('stepUpdated', data => {
            this.sequenceSteps = this.sequenceSteps.map(step => {
                if(step.id === data.id){
                    step = data
                }
                return step
            });
            this.selectedStepObj = null
        });
        Bus.$on('stepDeleted', data => {
            this.sequenceSteps = this.sequenceSteps.filter(step => step.id !== this.selectedStepObj.id);
            this.selectedStepObj = null
        });
    },
    methods: {
        goToPage(page) {
            this.page = page;
            this.advanced_search ? this.advancedSearch() : this.fetchData();
        },
        open(type) {
            this.fetchData();
            this.sequenceObj = {
                id: null,
                name: '',
                is_shared: false,
                business_days_only: false
            };
            this.sequenceSteps = [];
            this.modalFlag = type;
            setTimeout(function () {
                $("#emailSequenceModal").modal('show');
            }, 500);
        },
        backToListing(){
            this.fetchData();
            this.sequenceObj = {
                id: null,
                name: '',
                is_shared: false,
                business_days_only: false,
                unenrolled: false,
            };
            this.sequenceSteps = [];
            this.selectedStepObj = null;
            this.modalFlag = true;
            this.settingsTab = false;
            this.showButtons = false;
            this.showTemplateSection = false;
            this.selectedTemplate = null;
            this.showSendTestBtn = false;
        },
        debounceFilter: _.debounce(function (e) {
            this.filter = e.target.value;
            this.advanced_search = false;
            this.goToPage(1)
        }, 700),

        sortBy(column) {
            this.sort.direction = this.sort.column === column ? (this.sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';
            this.sort.column = column;
            this.goToPage(1);
        },

        fetchData() {
            let params = {
                filter: this.filter,
                column: this.sort.column,
                direction: this.sort.direction,
                page: this.page,
                sequence_type: this.project ? 'project': 'contact',
                project_id: this.project ? this.project.id : 'null',
                company_contact_id: this.selectedContactForSequence ? this.selectedContactForSequence.id: null
            }
            this.data_loading = true;
            axios.get(route('api.sequence.index'), {params}).then(({data}) => {
                this.emailSequences = data.data;
                this.pagination = data;
                this.data_loading = false;
                this.zero_search_results = (this.filter && this.emailSequences.length === 0);
            });
        },
        formatTime(time) {
          return moment(time).format('hh:mm A')
        },
        fetchTemplates() {
            axios.get(route('api.sequence.templates.list')).then(({data}) => {
                this.premadeTemplates = data.sequenceTemplates
                this.selectedTemplate = data.sequenceTemplates[0]
            });
        },
        openSequence() {
            this.sequenceObj = {
                id: null,
                name: '',
                is_shared: false,
                business_days_only: false,
                unenrolled: false
            }
            this.modalFlag = false;
            this.showButtons = true;
            this.showTemplateSection = false;
        },
        // addTemplate() {
        //     const sequenceName = this.sequenceObj.name;
        //
        //     if(!sequenceName && !templateText){
        //         this.errorFlag = true;
        //         this.error.name = 'Template name required';
        //         this.error.content = 'Template text required';
        //         return false;
        //     }
        //     if (!sequenceName) {
        //         this.errorFlag = true;
        //         this.error.name = 'Template name required';
        //         return false;
        //     }
        //     if(!templateText){
        //         this.errorFlag = true;
        //         this.error.content = 'Template text required';
        //         return false;
        //     }
        //     axios.post(route('api.template.store'), this.sequenceObj).then(({data}) => {
        //         if (data.success) {
        //             this.modalFlag = true;
        //             this.emailSequences = data.data.data;
        //             this.pagination.meta = {
        //                 total: data.data.total,
        //                 current_page: data.data.current_page,
        //                 per_page: data.data.per_page
        //             };
        //             this.data_loading = false;
        //             this.filter='';
        //             this.zero_search_results = (this.filter && this.emailSequences.length === 0);
        //         }
        //     });
        // },
        editSequence(sequence) {
            event.preventDefault()

            axios.get(route('api.sequence.show', {sequence: sequence.id})).then(({data}) => {
                this.sequenceObj = data.sequence;
                this.sequenceSteps = data.sequenceSteps;

            });
            this.modalFlag = false;
            this.settingsTab = false;
            this.showButtons = false;
         },
        destroySequence(id) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to delete this sequence?",
                icon: "warning",
                buttons: true,
                dangerMode: false,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {

                if (result.value) {
                    axios.delete(route('api.sequence.destroySequence', {'id': id}), ).then(
                        (response) => {
                            if (response.data.status){
                                Toast.fire({
                                    type: 'success',
                                    title: response.data.message
                                });
                                this.fetchData();
                            }else{
                                Toast.fire({
                                    type: 'error',
                                    title: response.data.message
                                });
                            }
                    });
                }
            })

        },
        addSequenceToEmail(sequence){
            if(this.project){
                this.$emit("addSequenceToEmail", sequence);
            }else{
                this.$emit("addSequenceToContactEmail", sequence);
            }
            $("#emailSequenceModal").modal('hide');
        },
        // emailBodyText(val){
        //     if(val){
        //         this.error.content='';
        //         this.sequenceObj.content = val;
        //     }else{
        //         this.sequenceObj.content = '';
        //     }
        // },
        editSequenceName(){
            this.editingSequenceName = true;
            this.error.sequenceName = false;
            $("#sequence_name").attr('disabled', false);
        },
        saveSequenceName(){
            this.editingSequenceName = false;
            $("#sequence_name").attr('disabled', true);
        },
        selectStep(step){
            this.selectedStepObj = step;
        },
        showSettings(val){
            this.settingsTab = val;
        },
        showSharedSequences(){
            this.emailSequences = this.emailSequences.filter(x => x.is_shared === 1);
        },
        saveSettings() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            let data = {
                id: this.sequenceObj.id,
                is_shared: this.sequenceObj.is_shared,
                business_days_only: this.sequenceObj.business_days_only,
                unenrolled: this.sequenceObj.unenrolled,
            }

            axios.post(route('api.sequence.saveSettings'),  data)
                .then((response) => {
                    if (response.data.status){
                        Toast.fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }

                });

        },
        toggleShowTemplates(){
            this.showButtons = false
            this.showTemplateSection = true
            this.selectedTemplate = this.premadeTemplates[0]
        },
        toggleShowButtons(){
            this.showButtons = false
            this.showTemplateSection = false
        },
        previewTemplate(step){
            this.selectedStepObj = step
            this.showSendTestBtn = true
        },
        selectTemplate(template){
            this.selectedTemplate = template
        },
        useTemplate() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            let data = {
                template_id: this.selectedTemplate.id,
                sequence_type: this.project ? 'project': 'contact',
                project_id: this.project ? this.project.id : null,
                company_contact_id: this.selectedContactForSequence ? this.selectedContactForSequence.id: null
            }
            axios.post(route('api.sequence.use-template'),  data)
                .then((response) => {
                    if(response.data.status){
                        Toast.fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.sequenceObj = response.data.sequence
                        this.sequenceSteps = response.data.sequenceSteps
                        this.showTemplateSection = false
                        this.showSendTestBtn = false
                        this.showButtons = false
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
        }
    }
}
</script>

<style scoped>
.pagination > li > a {
    color: #4dc0b5;
}

.pagination > li > a:hover {
    background-color: #4dc0b5 !important;
    color: white;
}

.cursor-pointer {
    cursor: pointer;
}

li.page-item.active > a {
    background-color: #4dc0b5 !important;
    border-color: #4dc0b5 !important;
}

a.page-link:focus {
    box-shadow: none;
}
.dayDropdown{
    background: #e6e8eb;
    height: 100%;
    padding: 0px 8px;
    border-radius: 4px;
}
.sequence-timepicker:first-child{
    width: 100% !important;
}
.sequence-name{
    background: none;
    color: #fff;
    font-size: 1.5rem;
}
.sequence-name:focus{
    outline: none;
}
.step-title{
    width: 180px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.step-title.active{
    color: #01b1af;
}
.steps-list-height{
    height: 660px;
    overflow-y: scroll;
}
.modal-min-height{
    min-height: 660px;
}
.setting-checkbox{
    width: 1.25rem;
    height: 1.25rem;
}
.custom-checkbox-section span{
    line-height: 40px;
}
.custom-sequence-button{
    border-radius:  10px;
    width: 190px;
}
.sequence-button-image{
    width: 100px;
    height: auto;
}
.main-container {;
    width: 100%;
    background: #e1e1e1;
    height: 595px;
    overflow: scroll;
}
.premade-templates-list {
    width: 40%;
    padding: 10px;
    background: #ffffff;
}
.premade-templates-steps {
    width: 60%;
    padding: 10px 0px 10px 10px;
    /*justify-content: space-between;*/
}
span.preview-btn {
    color: #01b1af;
}
.steps-button-div {
    text-align: end;
    margin-top: -60px;
    margin-right: 10px;
}
.step-template-title{
    width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
